// Sort a dropdown's data by the label users see without changing the source array.
export const sortByDisplayLabel = (items, getLabel) =>
  [...items].sort((a, b) =>
    String(getLabel(a) ?? '').localeCompare(String(getLabel(b) ?? ''), 'en', {
      sensitivity: 'base',
      numeric: true,
    })
  );
